import { useState } from "react";
export var useTableSort = function () {
    var _a = useState("desc"), orderBy = _a[0], setOrderBy = _a[1];
    var _b = useState("created_at"), sortBy = _b[0], setSortBy = _b[1];
    var onSort = function (property) {
        var isAsc = sortBy === property && orderBy === "asc";
        setOrderBy(isAsc ? "desc" : "asc");
        setSortBy(property);
    };
    return { onSort: onSort, orderBy: orderBy, sortBy: sortBy };
};
